import { useGetDiscountsQuery } from 'API/order/fees/DiscountApi';
import { useUpdateOrderTimberHook } from 'API/order/useUpdateOrderHook';
import { ReissueDiscounts } from 'components/order/discounts/ReissueDiscounts';
import { getOwnerDetails } from 'components/cdBuilder/getOwnerDetails';
import React, { useState } from 'react';
import { useSelectCurrentOrder, useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { loadItemsData } from 'store/order/cdBuilder';
import { updateDiscounts } from 'store/order/discounts';
import { useAppDispatch } from 'store/store';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { assertDefined } from 'utilities/Assertions';
import { useHasPermissions } from '../../accessControl/hooks/useHasPermissions';
import {
  convertFromReissueDiscountDataToReissueDiscountRequest,
  IReissueDiscountData,
} from '../../../ui-toolkit/discounts/types/IReissueDiscount';
import { eDiscountType } from '../../../ui-toolkit/discounts/types/eDiscountType';

export interface IReissueDiscountsContainerProps {
  onSave?: () => Promise<void>;
}

export const ReissueDiscountsContainer: React.FC<IReissueDiscountsContainerProps> = ({ onSave }) => {
  const id = useSelectCurrentOrderId();
  const { data: order } = useSelectCurrentOrder();
  assertDefined(id, 'Order ID');
  const hasEditPermissions = useHasPermissions([ePermissions.CdItemsV3Edit]);

  const { action: updateOrderAction } = useUpdateOrderTimberHook();
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onSubmitReissueDiscount = async (data: IReissueDiscountData) => {
    if (reissueDiscount) {
      setIsSubmitting(true);
      try {
        onSave && (await onSave());
        await updateOrderAction(order, {
          reissueDiscount: convertFromReissueDiscountDataToReissueDiscountRequest(data),
        });
        await dispatch(updateDiscounts(id, reissueDiscount.id));

        const ownerDetails = getOwnerDetails(order);
        await dispatch(loadItemsData(id, order.parties, ownerDetails));
      } catch (e: any) {}
      setIsSubmitting(false);
    }
  };
  const { data: discounts } = useGetDiscountsQuery(id);
  const reissueDiscount = discounts?.find((d) => d.discountType === eDiscountType.ReissueDiscount);
  const reissueDiscountValue = reissueDiscount?.priorPolicyDetails;
  return (
    <>
      {!!reissueDiscount && (
        <ReissueDiscounts
          reissueDiscount={reissueDiscountValue}
          onSubmitDiscount={onSubmitReissueDiscount}
          isSubmitting={isSubmitting}
          hasEditPermissions={hasEditPermissions}
        />
      )}
    </>
  );
};
